const listaDeTecnicos = (state) => {
    if (!state.items || !Array.isArray(state.items)) {
        return [];
    }
    return state.items;
}

const listaDeTecnicosPaginada = (state) => {
    return state.itemsPaginados;
}

const loadingCtrlTecnicos = (state) => {
    return state.carregando
}

export {
    listaDeTecnicos,
    listaDeTecnicosPaginada,
    loadingCtrlTecnicos
}
